var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTontakeMarqueeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 22,
    viewBox: "0 0 116 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20555 21.2483L6.20555 2.99125L0.112305 2.99125L0.112305 0.86765L14.5513 0.86765L14.5513 2.99125L8.51578 2.99125L8.51578 21.2483L6.20555 21.2483Z",
    fill: "url(#paint0_linear_191_7480)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1286 21.5432C22.0494 21.5432 20.4322 21.15 19.2771 20.3634C18.1412 19.5769 17.3423 18.4168 16.8802 16.8831C16.4374 15.3297 16.216 13.4224 16.216 11.1612C16.216 8.89995 16.4471 6.98282 16.9091 5.40979C17.3711 3.83675 18.1701 2.63731 19.306 1.81147C20.4611 0.965966 22.0686 0.543213 24.1286 0.543213C26.1885 0.543213 27.7865 0.956134 28.9223 1.78198C30.0774 2.60782 30.886 3.81709 31.3481 5.40979C31.8101 6.98282 32.0411 8.89995 32.0411 11.1612C32.0411 13.4814 31.8101 15.4182 31.3481 16.9716C30.9053 18.5053 30.1063 19.6556 28.9512 20.4224C27.8153 21.1696 26.2078 21.5432 24.1286 21.5432ZM24.1286 19.4491C25.6495 19.4491 26.8046 19.1542 27.5939 18.5643C28.3833 17.9744 28.9223 17.0699 29.2111 15.8508C29.4999 14.612 29.6443 13.0488 29.6443 11.1612C29.6443 9.33254 29.4902 7.789 29.1822 6.53057C28.8934 5.25248 28.3544 4.289 27.5651 3.64012C26.7757 2.97158 25.6302 2.63731 24.1286 2.63731C22.6269 2.63731 21.4814 2.97158 20.6921 3.64012C19.9028 4.289 19.3541 5.24265 19.0461 6.50108C18.7573 7.7595 18.6129 9.31287 18.6129 11.1612C18.6129 12.9898 18.7573 14.5235 19.0461 15.7623C19.3348 16.9814 19.8739 17.9056 20.6632 18.5348C21.4526 19.1443 22.6077 19.4491 24.1286 19.4491Z",
    fill: "url(#paint1_linear_191_7480)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0886 21.2483L36.0886 0.86765L40.3914 0.86765L47.8996 19.1542L48.4772 19.1542L48.4772 0.86765L50.7874 0.86765L50.7874 21.2483L46.5712 21.2483L38.9475 2.96175L38.3988 2.96175L38.3988 21.2483L36.0886 21.2483Z",
    fill: "url(#paint2_linear_191_7480)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6748 21.2483L59.6748 2.99125L53.5816 2.99125L53.5816 0.86765L68.0205 0.86765L68.0205 2.99125L61.9851 2.99125L61.9851 21.2483L59.6748 21.2483Z",
    fill: "url(#paint3_linear_191_7480)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4633 21.2483L72.9212 0.86765L77.9171 0.86765L83.3461 21.2483L81.0359 21.2483L79.6209 16.0868L71.1885 16.0868L69.7735 21.2483L67.4633 21.2483ZM71.6795 13.9926L79.13 13.9926L76.1555 2.87327L74.6539 2.87327L71.6795 13.9926Z",
    fill: "url(#paint4_linear_191_7480)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4275 21.2483L86.4275 0.86765L88.7377 0.86765L88.7377 10.3059L92.0009 10.1879L97.0257 0.86765L99.6825 0.86765L94.0513 11.1022L100 21.2483L97.2567 21.2483L92.0298 12.282L88.7377 12.4L88.7377 21.2483L86.4275 21.2483Z",
    fill: "url(#paint5_linear_191_7480)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.897 21.2483L102.897 0.86765L115.112 0.86765L115.112 2.96175L105.207 2.96175L105.207 9.86344L113.38 9.86344L113.38 11.928L105.207 11.928L105.207 19.1542L115.112 19.1542L115.112 21.2483L102.897 21.2483Z",
    fill: "url(#paint6_linear_191_7480)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_7480",
    x1: 0.50108,
    y1: 10.928,
    x2: 114.801,
    y2: 10.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#E204CC",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2304E2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#049FE2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#04E277",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#4BE204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#C3E204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#E2D904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E28904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20404",
    stopOpacity: 0.869792
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_191_7480",
    x1: 0.50108,
    y1: 10.928,
    x2: 114.801,
    y2: 10.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#E204CC",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2304E2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#049FE2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#04E277",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#4BE204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#C3E204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#E2D904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E28904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20404",
    stopOpacity: 0.869792
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_191_7480",
    x1: 0.50108,
    y1: 10.928,
    x2: 114.801,
    y2: 10.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#E204CC",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2304E2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#049FE2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#04E277",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#4BE204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#C3E204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#E2D904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E28904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20404",
    stopOpacity: 0.869792
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_191_7480",
    x1: 0.50108,
    y1: 10.928,
    x2: 114.801,
    y2: 10.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#E204CC",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2304E2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#049FE2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#04E277",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#4BE204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#C3E204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#E2D904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E28904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20404",
    stopOpacity: 0.869792
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_191_7480",
    x1: 0.50108,
    y1: 10.928,
    x2: 114.801,
    y2: 10.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#E204CC",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2304E2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#049FE2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#04E277",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#4BE204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#C3E204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#E2D904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E28904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20404",
    stopOpacity: 0.869792
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_191_7480",
    x1: 0.50108,
    y1: 10.928,
    x2: 114.801,
    y2: 10.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#E204CC",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2304E2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#049FE2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#04E277",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#4BE204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#C3E204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#E2D904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E28904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20404",
    stopOpacity: 0.869792
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_191_7480",
    x1: 0.50108,
    y1: 10.928,
    x2: 114.801,
    y2: 10.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#E204CC",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2304E2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#049FE2",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#04E277",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#4BE204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#C3E204",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#E2D904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E28904",
    stopOpacity: 0.869792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20404",
    stopOpacity: 0.869792
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTontakeMarqueeColor);
export default __webpack_public_path__ + "static/media/Tontake_marquee_color.a6b8549be0901880c1e07c5fdbfffdef.svg";
export { ForwardRef as ReactComponent };